import { MethodTypeRepository } from '@telespot/domain';

export interface IAnyMethodTypesForAssetTypeQuery {
  /**
   * Returns true if at least one method type references the given asset type.
   * Repository errors propagate so the caller can update its error state.
   */
  execute(assetTypeId: string): Promise<boolean>;
}

export class AnyMethodTypesForAssetTypeQuery implements IAnyMethodTypesForAssetTypeQuery {
  constructor(private readonly methodTypeRepository: MethodTypeRepository) {}

  public async execute(assetTypeId: string): Promise<boolean> {
    return this.methodTypeRepository.anyForAssetType(assetTypeId);
  }
}
